const defaultTheme = require('tailwindcss/defaultTheme');
const tailwindcssAspectRatio = require('tailwindcss-aspect-ratio');
const tailwindFilters = require('tailwindcss-filters');
const tailwindcssLineClamp = require('tailwindcss-line-clamp');
const tailwindUI = require('@tailwindcss/ui');
const hexRgb = require('hex-rgb');

function rgba(hex, alpha) {
  const { red, green, blue } = hexRgb(hex);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}

module.exports = {
  purge: ['./src/**/*.js'],
  theme: {
    aspectRatio: {
      none: 0,
      square: [1, 1],
      '16/9': [16, 9],
      '4/3': [4, 3],
      '3/4': [3, 4],
    },
    backdropFilter: {
      blur: `blur(${defaultTheme.spacing[1]})`,
    },
    lineClamp: {
      1: 1,
      2: 2,
      3: 3,
    },
    extend: {
      boxShadow: {
        ...tailwindUI.boxShadow,
        'outline-primary': '0 0 0 3px var(--shadow-color)',
      },
      cursor: {
        ...defaultTheme.cursor,
        'zoom-in': 'zoom-in',
      },
      colors: {
        gray: {
          50: '#fbfbfb',
          100: '#f7f7f7',
          200: '#ebebeb',
          300: '#dcdcdc',
          400: '#b2b2b2',
          500: '#808080',
          600: '#636363',
          700: '#515151',
          800: '#3f3f3f',
          900: '#2e2e2e',
        },
        pink: {
          50: '#fff4fa',
          100: '#ffe0f1',
          200: '#fcc7e5',
          300: '#faa5d3',
          400: '#f76aaf',
          500: '#f2308e',
          600: '#e2006d',
          700: '#c20c5b',
          800: '#99154b',
          900: '#751a3d',
        },
        blue: {
          50: '#ebf4ff',
          100: '#e2eeff',
          200: '#c5dbff',
          300: '#a4c4fe',
          400: '#749ffc',
          500: '#3f76f8',
          600: '#2157eb',
          700: '#1640bd',
          800: '#122775',
          900: '#0c153c',
        },
        black: '#2c2c2c',
        'true-black': '#000',
        brand: {
          'default-shadow': `${rgba(defaultTheme.colors.blue[400], 0.45)}`,
          pink: '#e2006d',
          'pink-shadow': `${rgba('#f76aaf', 0.45)}`,
          blue: '#0c153c',
          'blue-shadow': `${rgba('#1640bd', 0.45)}`,
        },
        primary: 'var(--brand-color)',
        'primary-light': 'var(--brand-color-light)',
        'primary-lighter': 'var(--brand-color-lighter)',
      },
      fontFamily: {
        sans: ['Century Gothic', ...defaultTheme.fontFamily.sans],
      },
      minWidth: {
        10: '2.5rem',
        ...defaultTheme.minWidth,
      },
    },
  },
  variants: {
    backgroundOpacity: [
      'responsive',
      'hover',
      'focus',
      'active',
      'group-focus',
      'group-hover',
    ],
    borderWidth: ['responsive', 'first'],
    cursor: ['responsive', 'disabled'],
    margin: ['responsive', 'first', 'last'],
    opacity: ['responsive', 'hover', 'focus', 'disabled'],
    padding: ['responsive', 'first', 'last'],
    scale: ['responsive', 'hover', 'group-focus', 'group-hover'],
  },
  plugins: [
    tailwindcssAspectRatio,
    tailwindFilters,
    tailwindcssLineClamp,
    tailwindUI,
  ],
};
